/**
 * Technician “My focus” dashboard tab — gated by LaunchDarkly `technician-dashboard`
 * (and camelCase / bracket variants commonly returned by ``useFlags()``).
 */

export function isTechnicianDashboardLdEnabled(
  flags: Record<string, unknown> | undefined
): boolean {
  if (!flags || typeof flags !== "object") {
    return false;
  }
  const f = flags as Record<string, unknown>;
  return (
    f.technicianDashboard === true ||
    f.techniciandashboard === true ||
    f["technician-dashboard"] === true
  );
}
